/**============================================================
*   [changeRegisterTab]
*   description : 職歴登録タブ切り替え
============================================================*/
document.addEventListener('DOMContentLoaded', () => {
  const tabTriggers = document.querySelectorAll('.js-tab-trigger');
  const path = location.pathname;

  if ((path.indexOf('/confirm') === -1) && tabTriggers) {
    const tabTargets = document.querySelectorAll('.js-tab-target');
    tabTriggers.forEach(tabTrigger => {
      tabTrigger.addEventListener('click', (e) => {
        let currentMenu = e.currentTarget;
        let currentContent = document.getElementById(currentMenu.dataset.id);
        tabTriggers.forEach(tabTrigger => {
          tabTrigger.classList.remove('current');
        });
        currentMenu.classList.add('current');
        tabTargets.forEach(tabTarget => {
          tabTarget.classList.remove('current');
        });
        if (currentContent !== null) {
          currentContent.classList.add('current');
        }
      });
    });
  } else if ((path.indexOf('/confirm') !== -1) && tabTriggers) {
    tabTriggers.forEach(tabTrigger => {
      tabTrigger.style.cursor = 'inherit';
    });
  }
});
